<template>
  <div class="v-breadcrumbs">
    <div
      v-if="items?.length > 0"
      class="v-breadcrumbs__item"
      v-for="(item, index) in items"
      :key="index"
    >
      <router-link :to="routes[0].path + tab" class="v-breadcrumbs__name" v-if="0 === index">
          {{ routes[0].meta.name }}
      </router-link>
      <img
        src="@/assets/images/icons/arrow-right-gray.svg"
        class="v-breadcrumbs__arrow"
        alt="arrow"
      />
        <component
          v-if="index > 0"
          :is="items?.length === index + 1 ? 'div' : 'a'"
          :href="item?.id"
          class="v-breadcrumbs__name"
        >
          {{ item?.name }}
        </component>
    </div>
  </div>
</template>

<script setup>
import {useRoute} from "vue-router";
import {computed, onActivated, ref} from "vue";

const route = useRoute();
const routes = ref(route.matched)

const props = defineProps({
  customRouteIndex: Number,
  customRouteLink: String,
  tab: {
    type: String,
    default: "",
  },
  itemsBreadcrumbs: {
    type: Array,
  }
})

const items = computed(() => {
  let items = ref([{}]);

  if (props.itemsBreadcrumbs?.length > 0) {
    items.value.push(...props.itemsBreadcrumbs);
  }
  return items.value
})

onActivated(() => {
    routes.value = route.matched
})
</script>

<style scoped lang="scss">
.v-breadcrumbs {
    display: flex;

    &__item {
      display: flex;
      align-items: center;
      justify-items: center;
    }

    &__name {
      font-size: 12px;
      font-weight: 400;
      color: $gray;
      text-decoration: none;
    }

    &__items {
      font-size: 12px;
      font-weight: 400;
      color: $gray;
      text-decoration: none;
    }

    &__arrow {
      width: 12px;
      height: 12px;
      margin-top: 2px;
      margin-left: 2px;
      margin-right: 2px;
    }

}
</style>
